import { KeyDetail } from "./key-detail";
export default KeyDetail;
